/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_CutInputs */



/**
* | output |
* | --- |
* | "Cut event or selected text" |
*
* @param {Shortcut_Keys_Desc_CutInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_cut = /** @type {((inputs?: Shortcut_Keys_Desc_CutInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_CutInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Couper l'evenement ou le texte selectionne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignis oder ausgewählten Text ausschneiden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Taglia l'evento o il testo selezionato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вырезать событие или выделенный текст")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cortar evento o texto seleccionado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("剪切事件或选定文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントまたは選択したテキストを切り取る")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट या चयनित टेक्स्ट को काटें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Recortar evento ou texto selecionado")
	return /** @type {LocalizedString} */ ("Cut event or selected text")
});